export const D18 = "D18";
export const D19 = "D19";
export const D20 = "D20";
export const D21 = "D21 💜";
export const D22 = "D22 💙";
export const D23 = "D23 💚";
export const D24 = "D24 💗";
export const D25 = "D25 💛";
export const ATTT = "ATTT";
export const BC = "BC";
export const CNDPT_PTUDDPT = "CNDPT_PTUDDPT";
export const CNDPT_TKDHDPT = "CNDPT_TKDHDPT";
export const CNKTDDT_KTDTMT = "CNKTDDT_KTDTMT";
export const CNKTDDT_XLTHVTT = "CNKTDDT_XLTHVTT";
export const CNTCF = "CNTCF";
export const CNTT_CNPM = "CNTT_CNPM";
export const CNTT_HTTT = "CNTT_HTTT";
export const KT = "KT";
export const KHMT = "KHMT";
export const KTDTVT_HTI = "KTDTVT_HTI";
export const KTDTVT_MVDVI = "KTDTVT_MVDVI";
export const KTDTVT_TTVTVDD = "KTDTVT_TTVTVDD";
export const M_IM = "M_IM";
export const M_PTDLMS = "M_PTDLMS";
export const QTKD_QTDN = "QTKD_QTDN";
export const QTKD_TMDT = "QTKD_TMDT";
export const TMDT = "TMDT";
export const TTDPT = "TTDPT";
export const CNTT_CLC = "CNTT_CLC";
export const CNTT_UDU = "CNTT_UDU";
export const KTDL = "KTDL";
export const KT_DK_V_TDH = "KT_DK_V_TDH";
export const M_CLC = "M_CLC";
export const KT_CLC = "KT_CLC";
export const IOT = "IOT";
export const TK_V_PTG = "TK_V_PTG";
export const CNTT_VN = "CNTT_VN";
export const QTKD_LOGISTICS = "QTKD_LOGISTICS";
export const ATTT_CLC = "ATTT_CLC";
export const TTNT = "TTNT";
